module.exports = __webpack_public_path__ + "static/img/placeholder1.53e4bcc.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placeholder1.gif
// module id = Vszq
// module chunks = 1